(ns frontend.view.settings2.sales-pipelines.view
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.view.entity :as f-entity]
   [frontend.view.modals.curtains.pipeline-settings-curtain.view :as pipeline-settings-curtain]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.pipeline-edit.view :as pipeline-edit]
   [frontend.view.settings2.creation-flow-toggle.view :as creation-flow-toggle]
   [frontend.view.settings2.sales-pipelines.db :as db]
   [reagent.core :as r]
   [ui.components.breadcrumbs.view :as breadcrumbs]
   [ui.components.button.view :as button]))

(defn breadcrumbs
  []
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [_]
                 (routing/set-view! [:account-settings :tab-key "config"]))}
    (loc/tr :settings/account-settings)]
   [breadcrumbs/item
    {:active? true}
    (loc/tr :settings/sales-pipelines)]])

(defn pipeline-row
  [all-sales-pipelines all-teams pipeline]
  (let [disabled? (:common/disabled? pipeline)
        inactive? (:pipeline/inactive? pipeline)
        pipeline-name (:pipeline/name pipeline)
        target-asset-types (:pipeline/target-asset-types pipeline)
        pipeline-teams (->> pipeline
                            :pipeline/teams
                            (map (fn [team-id]
                                   (get @session/entities team-id)))
                            (remove :common/disabled?))
        pipeline-stages (->> @session/all-sales-opportunity-stages
                             (remove :common/disabled?)
                             (cu/filter-by :sales-opportunity-stage/pipeline (:db/id pipeline))
                             (sort-by :common/ord))
        pipeline-id (:db/id pipeline)
        other-pipelines (->> all-sales-pipelines
                             (remove (fn [{:keys [db/id]}]
                                       (= pipeline-id id))))]
    [:tr
     {:class-name "*:px-3 *:py-4
                   *:whitespace-nowrap *:text-sm *:text-base-light-text"
      :key        (str "pipeline-row-" pipeline-name)}
     [:td
      (cond disabled?
            (loc/tr :disabled)
            inactive?
            (loc/tr :archived)
            :else
            (loc/tr :active))]
     [:td
      [:div
       {:class "flex items-center gap-2"}
       pipeline-name]]
     [:td
      [:ul
       (->> pipeline-teams
            (map (fn [team]
                   [:li
                    {:key (str "pipeline-team-" pipeline-name "-" (:db/id team))}
                    (entity/display-string team)]))
            (doall))]]
     [:td
      [:ul
       (doall
        (for [target-type target-asset-types]
          ^{:key (str "pipeline-asset-type-" pipeline-name "-" target-type)}
          [:li
           {:class "flex items-center"}
           (loc/tr target-type)]))]]
     [:td
      [:div
       {:class "flex items-baseline gap-3"}
       [:ul
        {:class "flex flex-wrap gap-2"}
        (->> pipeline-stages
             (map (fn [stage]
                    [:li
                     {:class "py-1 px-2 bg-complement-regular rounded-full"
                      :key   (str "pipeline-stage-" pipeline-name "-" (:db/id stage))}
                     (entity/display-string stage)]))
             (doall))]
       (when-not disabled?
         [button/square-secondary-open
          {:dom-id   (str "sales-pipeline-stage-edit-button-" pipeline-name)
           :tooltip  (loc/tr :tooltip/configure-pipeline-stages)
           :class    "pt-1"
           :on-click (fn [_]
                       (modals/open-modal!
                        pipeline-settings-curtain/modal-key
                        {:pipeline-id          (:db/id pipeline)
                         :stage-entity-type    :entity.type/sales-opportunity-stage
                         :stage-name-attribute :sales-opportunity-stage/name
                         :pipeline-attribute   :sales-opportunity-stage/pipeline}))}
          [:i.fas.fa-pen]])]]
     [:td
      (when-not disabled?
        [button/square-secondary-open
         {:tooltip  (loc/tr :show-permissions)
          :on-click (fn [_]
                      (routing/set-view! [:settings.permissions/pipeline :id
                                          (:db/id pipeline)]))}
         [:i.fas.fa-user-lock]])]
     [:td
      (when-not disabled?
        [button/square-secondary-open
         {:tooltip  (loc/tr :edit)
          :on-click (fn [_]

                      (modals/open-modal! pipeline-edit/modal-key
                                          {:pipeline-id        (:db/id pipeline)
                                           :target-asset-label (loc/tr :customer-types)
                                           :existing-teams     all-teams
                                           :existing-pipelines other-pipelines}))}
         [:i.fas.fa-ellipsis-v]])]]))

(defn component
  []
  (r/create-class
   {:reagent-render
    (fn []
      (let [all-teams (->> @session/all-teams
                           (remove :common/disabled?))
            sales-pipelines @session/sales-oppo-pipelines
            start-value {:pipeline/entity-type       :entity.type/sales-opportunity
                         :pipeline/target-asset-types [:entity.type/company]}]
        [:<>
         [zap-toolbar/view db/state breadcrumbs nil nil]
         [:div
          {:class "h-[calc(100vh_-_52px-_50px)] overflow-auto
                   text-base-light-text
                   bg-base-light"}
          [:div
           {:class "max-w-full inline-flex px-4 py-4"}
           [:div
            {:class "max-w-full md:p-3 flex flex-col gap-4"}
            (when (session/froppo-creation-flow-feature?)
              [:div
               {:class "flex flex-row gap-4"}
               [creation-flow-toggle/view
                {:preference-key    :sales-oppo-creation-flow
                 :title-loc-key     :new-sales-opportunity-creation-flow
                 :for-me-loc-key    :sales-oppo-creation-flow-toggle-for-me
                 :for-all-loc-key   :sales-oppo-creation-flow-toggle-for-all
                 :info-loc-key      :creation-flow-toggle-info
                 :info-icon-tooltip (loc/tr :sales-oppo-creation-flow-toggle-info-icon
                                            [(loc/tr :creator-config-item-label)])}]

               (when (and (session/entry-criteria-feature?)
                          (session/sales-oppo-creation-flow?))
                 [creation-flow-toggle/view
                  {:info-icon-tooltip (loc/tr :stage-entry-criteria-info)
                   :preference-key :stage-entry-criteria-sales-oppo
                   :title-loc-key :stage-entry-criteria-for-sales-opportunities
                   :for-me-loc-key :toggle-for-me
                   :for-all-loc-key :toggle-for-all}])])
            (if (empty? sales-pipelines)
              [:div
               {:class "w-screen flex flex-col gap-6 justify-center items-center"}
               [:img
                {:src        "/img/no-data-created.svg"
                 :class-name "max-w-32 mx-auto"}]
               [button/sm-primary-solid
                {:tooltip   (when (not (session/has-feature-access?
                                        :feature/sales-pipelines))
                              (loc/tr :feature-not-enabled))
                 :disabled? (not (session/has-feature-access? :feature/sales-pipelines))
                 :on-click  (fn [_]
                              (f-entity/open-creator! :entity.type/pipeline
                                                      {:start-value start-value
                                                       :on-ok!      (fn [{:keys [_new-entity-id close-cb!]}]
                                                                      (close-cb!))}))}
                [:span
                 [:i {:class "fal fa-plus"}]]
                (loc/tr :settings/create-sales-pipelines)]]
              [:div {:class "max-w-full md:p-3 inline-flex flex-col justify-between gap-4"}
               [:div {:class "flex justify-between items-center"}
                [:h2
                 {:class "font-semibold text-xl"}
                 (loc/tr :settings.pipelines/pipelines-heading)]
                [button/sm-primary-solid
                 {:tooltip   (when (not (session/has-feature-access?
                                         :feature/sales-pipelines))
                               (loc/tr :feature-not-enabled))
                  :disabled? (not (session/has-feature-access? :feature/sales-pipelines))
                  :on-click  (fn [_]
                               (f-entity/open-creator! :entity.type/pipeline
                                                       {:start-value start-value
                                                        :on-ok!      (fn [{:keys [_new-entity-id close-cb!]}]
                                                                       (close-cb!))}))}
                 [:span
                  [:i {:class "fal fa-plus"}]]
                 (loc/tr :settings/create-sales-pipelines)]]
               (when (seq sales-pipelines)
                 [:div
                  {:class "max-w-full border border-solid border-base-light-border-paler rounded-lg overflow-x-auto overflow-y-hidden"}
                  [:table
                   {:class "w-full md:w-auto  divide-y divide-solid divide-base-light-border-paler"}
                   [:thead
                    [:tr
                     {:class "*:px-3 *:py-3.5 *:text-left *:text-sm *:font-semibold *:text-base-light-text"}
                     [:th (loc/tr :settings.pipelines/table-heading-status)]
                     [:th (loc/tr :settings.pipelines/table-heading-name)]
                     [:th (loc/tr :settings.pipelines/table-heading-teams)]
                     [:th (loc/tr :customer-types)]
                     [:th (loc/tr :settings.pipelines/table-heading-stages)]
                     [:th (loc/tr :settings.pipelines/table-heading-permissions)]
                     [:th (loc/tr :settings.pipelines/table-heading-edit)]]]
                   [:tbody
                    {:class "divide-y divide-solid divide-base-light-border-paler"}
                    (->> sales-pipelines
                         (sort-by :pipeline/name)
                         (map (partial pipeline-row sales-pipelines all-teams))
                         (doall))]]])])]]]]))}))

(defmethod routing/render-view :settings/sales-pipelines
  [_]
  [default-page-layout/view
   {:class "hidden"}
   [component]])
